// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".logo.svelte-1u417p3 svg.svelte-1u417p3{fill:var(--primary)}.footer.svelte-1u417p3.svelte-1u417p3{width:70px;height:auto;margin:10px 0}.front.svelte-1u417p3.svelte-1u417p3{width:70px;height:auto;padding:10px}", ""]);
// Exports
module.exports = exports;
